import { render } from "./CustomFooter-editor.vue?vue&type=template&id=0ef2c8d0&scoped=true"
import script from "./CustomFooter-editor.vue?vue&type=script&lang=js"
export * from "./CustomFooter-editor.vue?vue&type=script&lang=js"

import "./CustomFooter-editor.vue?vue&type=style&index=0&id=0ef2c8d0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef2c8d0"]])

export default __exports__